<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>
              <span style="color:#007BFFFF;">吴丰胜</span>
              <i class="el-icon-arrow-down icon"></i>
            </li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
      <div class="top_china" style="background:#fff;">
        <div class="top_china_cent">
          <div class="top_china_img">
            <img src="../../assets/img/top_logo.png" alt />
            <p>
              <span style="color:#999999FF;font-size:16px;">/</span> 个人中心
            </p>
          </div>
          <div class="top_china-sc">
            <p>基于商会的一站式企业服务平台</p>
            <p>|</p>
            <div class="top_china_bot">
              <img src="../../assets/img/top_slogan.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="conent">
      <div class="conetn_1">
        <div class="conetn_left">
          <div class="conetn_left_1">
            <p>个人中心</p>
          </div>
          <ol class="conetn_left_2">
            <router-link :to="{name:'dingdang',query:{token:this.$route.query.token}}" tag="li">
              <img src="../../assets/img/geren/nav_btn_invoice_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt /> -->
              <p>
                <a href="#">我的订单</a>
              </p>
            </router-link>
            <li @click="dialogVisible = true">
              <img src="../../assets/img/geren/nav_btn_invoice_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p>
                <a href="#">我的发票</a>
              </p>
            </li>
            <router-link :to="{path:'/zhinang'}" tag="li">
              <img src="../../assets/img/geren/nav_btn_znt_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p>
                <a href="#">我的智囊团</a>
              </p>
            </router-link>
            <router-link :to="{path:'/tiwen'}" tag="li">
              <!-- <img src="../../assets/img/geren/nav_btn_ask_nor.png" alt /> -->
              <img src="../../assets/img/geren/nav_btn_ask_sel.png" alt />
              <p>
                <a href="#" style="color:#007BFF;">我的提问</a>
              </p>
            </router-link>
          </ol>
        </div>
        <div class="content_right">
          <div class="content_right_dd">
            <p>我的提问</p>
          </div>
          <div class="content_right_2">
            <div class="content_right_2_top">
              <p @click="idd()">
                <a href="#">我要咨询</a>
              </p>
            </div>
            <div class="content_right_2_bot">
              <ul v-if="this.id == '26'">
                <li v-for="(item,index) in quest" :key="index" @click="newcc(item.id)">
                  <div class="content_right_img">
                    <img src="../../assets/img/geren/personal_icon_ask.png" alt />
                  </div>
                  <div class="content_right_p">
                    <p>{{item.questions_title}}</p>
                    <p class="content_right_p1">咨询内容：{{item.questions_content}}</p>
                    <p v-if="item.is_read == 0">
                      {{item.updated_at}}
                      <span style="padding:0 15px;">|</span>
                      <span>{{item.status}}</span>
                    </p>
                    <p v-else>
                      {{item.created_at}}
                      <span style="padding:0 15px;">|</span>
                      <span>{{item.status}}</span>
                    </p>
                  </div>
                </li>
              </ul>
              <ul v-if="this.id == '1'">
                <li v-for="(item,index) in quest" :key="index" @click="newcc(item.id)">
                  <div class="content_right_img">
                    <img src="../../assets/img/geren/personal_icon_ask.png" alt />
                  </div>
                  <div class="content_right_p">
                    <p>{{item.questions_content}}</p>
                    <p class="content_right_p1">咨询内容：{{item.content}}</p>
                    <p v-if="item.is_read == 0">
                      {{item.updated_at}}
                      <span style="padding:0 15px;">|</span>
                      <span>{{item.status}}</span>
                    </p>
                    <p v-else>
                      {{item.created_at}}
                      <span style="padding:0 15px;">|</span>
                      <span>{{item.status}}</span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <!-- <div class="content_right_fenye">
              <el-pagination
                class="fenye"
                :page-size="1"
                background
                layout="prev, pager, next"
                :total="8"
              >
              </el-pagination>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <div class="dialog">
        <img src="../../assets/img/geren/pop_QR.png" alt />
        <p>请前往小程序进行操作</p>
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      dialogVisible: false,
      quest: []
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    table(index) {
      this.numm = index;
    },
    questionsList() {
      this.imember_idd = localStorage.getItem("member_id");
      this.id = localStorage.getItem("city_id");
      if (this.id == "1") {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/questionsList",
          {
            questions_id: this.imember_idd
            // 366
          },
          "post"
        ).then(res => {
          this.quest = res.data.data;
        });
      }
      if (this.id == "26") {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/questionsListQy",
          {
            member_id: this.imember_idd
          },
          "post"
        ).then(res => {
          this.quest = res.data.data;
        });
      }
    },
    idd() {
      this.$router.push({
        name: "zhitongche"
      });
    },
    newcc(id) {
      this.$router.push({
        name: "tiwenliebiao",
        query: {
          questions_id: id
        }
      });
    }
  },
  created() {
    this.questionsList();
    this.$emit("header", true); //是否显示头部
    this.id = localStorage.getItem("city_id");
  }
};
</script>

<style scoped>
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
  margin-top: 40px;
}

.top_china-sc {
  float: right;
}

.top_china-sc p {
  float: left;
  line-height: 100px;
  padding: 0 10px;
  font-size: 14px;
  color: #b2b2b2;
}

.dialog {
  width: 28%;
  height: auto;
  margin: 0 auto;
  text-align: center;
}

.dialog p {
  text-align: center;
  margin: 20px 0;
  font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222ff;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.top_china {
  width: 100%;
  overflow: hidden;
}

.top_china_cent {
  width: 1200px;
  margin: 0 auto;
}

.top_china_img img {
  padding: 19px 0;
  float: left;
}

.top_china_scout {
  width: 448px;
  height: 44px;
  background: #007bff;
  float: left;
  margin: 19px 0;
  border-radius: 5px;
  margin-right: 11px;
}

.top_china_img p {
  float: left;
  line-height: 82px;
  font-size: 24px;
  font-weight: bold;
  color: #666666ff;
  margin-left: 15px;
}

.input {
  width: 348px;
  height: 38px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  outline: none;
  border: 0;
  margin: 3px 0 0 3px;
  font-size: 16px;
  float: left;
}

.btn {
  width: 97px;
  height: 44px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  outline: none;
  border: 0;
  background: #007bff;
  font-size: 16px;
  color: #fff;
}
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
}

.butoon {
  width: 150px;
  height: 44px;
  margin: 19px 0;
  background: #f7681e;
  outline: 0;
  border: 0;
  font-size: 16px;
}

.top_china-sc {
  float: right;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.conent {
  width: 100%;
  height: auto;
  background: #f4f5f9ff;
  overflow: hidden;
}

.conetn_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  margin-top: 30px;
}

.conetn_left {
  width: 240px;
  height: 284px;
  background: #fff;
  float: left;
}

.conetn_left_1 {
  width: 100%;
  height: 57px;
  border-bottom: 1px solid #e4e4e4ff;
}

.conetn_left_1 p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  padding: 18px 0 0 30px;
}

.conetn_left_2 {
  margin-top: 20px;
}

.conetn_left_2 li {
  width: 240px;
  height: 44px;
}

.conetn_left_2 img {
  float: left;
  padding: 14px 5px 0 29px;
}

.conetn_left_2 p a {
  float: left;
  line-height: 44px;
  font-size: 14px;
  color: #222222ff;
}

.content_right {
  width: 940px;
  height: auto;
  float: right;
}

.content_right_dd {
  width: 100%;
  height: 58px;
  border-bottom: 1px solid #e4e4e4;
  background: #ffffff;
}

.content_right_dd p {
  color: #222222;
  font-weight: 600;
  line-height: 58px;
  padding: 0 30px;
}

.content_right_2 {
  width: 100%;
  height: auto;
  background: #fff;
  margin-bottom: 144px;
  overflow: hidden;
}

.content_right_fenye {
  width: 100%;
  height: 102px;
  overflow: hidden;
  text-align: center;
  padding: 35px 0;
}

.content_right_2_top {
  width: 910px;
  height: 70px;
  border-bottom: 1px solid #e4e4e4;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 28px;
}

.content_right_2_top p {
  width: 100px;
  height: 30px;
  background: #007bff;
  text-align: center;
  border-radius: 4px;
  margin: 20px 20px;
}

.content_right_2_top p a {
  color: #fff;
  line-height: 30px;
  font-size: 12px;
}

.content_right_2_bot {
  width: 910px;
  height: auto;
  margin: 0 auto;
}

.content_right_img {
  float: left;
  margin-right: 18px;
}

.content_right_2_bot ul li {
  width: 100%;
  height: 160px;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 29px;
}

.content_right_p {
  width: 828px;
  height: 160px;
  float: left;
}

.content_right_p p:first-child {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 400;
}
.content_right_p p:nth-child(2) {
  font-size: 14px;
  color: #666666;
  margin-bottom: 30px;
}

.content_right_p p:nth-child(3) {
  float: right;
  font-size: 14px;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/view/Geren/Tiwen.vue